import { botMessages } from "../Constants/messages";

export const getTimeoutValue = () => {
  return 1000;
};

export const getBetweenTimeoutValue = () => {
  return 2500;
};

export const getInputTimeoutValue = () => {
  return 1500;
};

export const getBotMessageGroup = () => {
  return botMessages.shift();
};

export const addBotMessageGroup = msgGroup => {
  return botMessages.unshift(msgGroup);
};

export const getBotMessage = message => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(message);
    }, getTimeoutValue(message.message));
  });
};



// WEBPACK FOOTER //
// ./src/Utils/botMessages.js